/**
 * Default chat texts the bot posts in a channel. Chat templates are channel
 * content, not source text: they stay in the channel's language and are not
 * translated with the code (docs/input/umbau-plan.md, "Chatvorlagen").
 */
export const DEFAULT_TEXT_LONG = "Willkommen {channel}! Danke für den Raid mit {viewers} Zuschauern — schaut gerne vorbei!";
export const DEFAULT_TEXT_SHORT = "Danke für den Raid, {channel}, mit {viewers} Zuschauern!";
